import React from 'react';
import Globalizer from '../../../globalizer';
import translateService from '../../../common/translateService';
import common from '../../../common/common';
import ProductTags from './ProductTags.jsx';
import ReviewStars from '../reviews/ReviewStars.jsx';
import './ProductCard.scss';

const ProductCard = ({ p }) => {
    Globalizer.init();

    function handleProductClick(link) {
        window.location =
            link[0] === '/'
                ? common.getSiteUrl('/') + link
                : common.getSiteUrl('/') + '/' + link;
    }

    return (
        <article
            className='article product'
            onClick={() => handleProductClick(p.productUrl)}>
            <ProductTags
                latestArrival={p.latestArrival}
                offer={p.offer}
                tags={p.tags}
                offerdata={p.offerdata}
            />
            <div className='product__container'>
                <div className='article__figure-container'>
                    <figure className='article__figure'>
                        <a className='link' href={p.productUrl} title={p.title}>
                            <img
                                className='article__image'
                                data-src={common.contentFromCdn({
                                    path: p.imageSrc,
                                    keepUrlAsIs: false,
                                })}
                                alt={p.title}
                                data-flickity-lazyload={common.contentFromCdn({
                                    path: p.imageSrc,
                                    keepUrlAsIs: false,
                                })}
                            />
                        </a>
                    </figure>
                </div>
                <hr className='product__divider' />
                <header className='product__header'>
                    <span className='product__header-brand-and-price-container'>
                        <span className='product__brand'>{p.brand}</span>
                        <span className='product__price'>
                            <span>
                                {p.hasManyPrices && (
                                    <small>{`${translateService.get(
                                        `productCard.ProductPriceStartingFrom`
                                    )} `}</small>
                                )}
                                <span content={p.currencyCode}>
                                    <strong>{p.currencySymbol}</strong>
                                </span>{' '}
                                &nbsp;
                                <span
                                    content={p.price.toFixed(
                                        p.currencyDecimalPlaces
                                    )}>
                                    <strong>
                                        {Globalizer.formatNumber(
                                            p.price,
                                            p.currencyDecimalPlaces
                                        )}
                                    </strong>
                                </span>
                            </span>
                        </span>
                    </span>
                    <span className='product__header-title-and-discount-container'>
                        <span className='product__title'>
                            <h1 className='article__title'>
                                <a
                                    className='article__link'
                                    href={p.productUrl}
                                    title={p.title}>
                                    {p.title}
                                </a>
                            </h1>
                        </span>
                        <span className='product__discount'>
                            {p.discount !== 0 && (
                                <span className='product__price--discount'>
                                    -{p.discount}%
                                </span>
                            )}
                        </span>
                    </span>
                    {p.ratingAverage !== 0 && (
                        <div>
                            <ReviewStars
                                maxRating={5}
                                average={p.ratingAverage}
                            />
                        </div>
                    )}
                    <div className='product-secondarylabels-container'>
                        {p.freeShipping && (
                            <div className='prd-notes-free-shipping'>
                                <img
                                    className='prd-notes-icon-small'
                                    src={common.contentFromCdn({
                                        path: '/content/img/fast-delivery.svg',
                                        keepUrlAsIs: false,
                                    })}
                                />{' '}
                                <p>
                                    {translateService.get(
                                        `productCard.FreeShipping`
                                    )}
                                </p>
                            </div>
                        )}
                        {p.hasManyColors && (
                            <span className='article__label article__label--other-colors-available'>
                                {translateService.get(
                                    `productCard.OtherColorsAvailable`
                                )}
                            </span>
                        )}
                    </div>
                </header>
            </div>
        </article>
    );
};

export default ProductCard;
